if (!customElements.get('category-slider')) {
  customElements.define(
    'category-slider',
    class CategorySlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.nav = this.querySelector('[data-nav]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.prev.addEventListener('click', () => this.step(-1));
        this.next.addEventListener('click', () => this.step(1));
        this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      queueUpdate() {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      // The arrows show only while the row is wider than the screen, and each
      // end disables the arrow that would lead nowhere.
      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const overflowing = scrollWidth > clientWidth + 2;
        this.nav.hidden = !overflowing;
        this.prev.disabled = scrollLeft <= 2;
        this.next.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
      }

      // Move by the cards that are fully in view, so the next set lands where
      // the first one was.
      step(direction) {
        const slide = this.track.querySelector('.category-slider__slide');
        if (!slide) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const width = slide.getBoundingClientRect().width + gap;
        const inView = Math.max(1, Math.floor((this.track.clientWidth + gap) / width));
        this.track.scrollBy({
          left: direction * inView * width,
          behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
        });
      }
    }
  );
}
